import React from 'react';
import QuickViewContent from 'components/Productions/Display/QuickView/QuickViewContent/QuickViewContent';

import classes from './MobileProductionStubPage.module.scss';

const MobileProductionStubPage = ({ entity }) => (
  <QuickViewContent production={entity} styles={{ body: classes.body }} isMobileStubPage />
);

export default MobileProductionStubPage;
